import React from 'react';
import {
  FormControl,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItemButton,
  ListItem,
  ListItemText
} from '@mui/material';
import { useGetAIPageDealTitle } from '@hooks/useAI';
import SpinningIcon from '@components/SpinningIcon';

const AIPostTitle = React.memo(
  ({
    value,
    onChange
  }: {
    value: string;
    onChange: (value: string) => void;
  }) => {
    const { mutate: getPageDealTitleSuggestions, isLoading } =
      useGetAIPageDealTitle();
    const [open, setOpen] = React.useState(false);
    const [suggestions, setSuggestions] = React.useState<string[]>([]);

    const handleSuggestionClick = (suggestion: string) => {
      onChange(suggestion);
      handleClose();
    };

    const handleClose = () => {
      setOpen(false);
      setSuggestions([]);
    };

    const renderTitleSuggestions = () => {
      if (!open) {
        return null;
      }
      return (
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Select title suggestion</DialogTitle>
          <List sx={{ pt: 0 }}>
            {suggestions.map((suggestion) => (
              <ListItem disableGutters key={suggestion}>
                <ListItemButton
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <ListItemText primary={suggestion} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Dialog>
      );
    };

    return (
      <FormControl margin="normal" fullWidth>
        {renderTitleSuggestions()}
        <TextField
          fullWidth
          label="Title"
          value={value}
          autoComplete="off"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.value);
            // console.log('e.target.value:', e.target.value);
          }}
        />
        <Button
          startIcon={isLoading ? <SpinningIcon isLoading /> : undefined}
          onClick={() => {
            getPageDealTitleSuggestions(
              { title: value },
              {
                onSuccess: (data) => {
                  setSuggestions(data?.suggestions || []);
                  setOpen(true);
                }
              }
            );
          }}
          disabled={!value || isLoading}
        >
          Get Suggestions
        </Button>
      </FormControl>
    );
  }
);

export default AIPostTitle;
